module.exports = __webpack_public_path__ + "img/mailMessageEN.ab09fee7.png";